var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"asyncModal"},on:{"closed":_vm.close}},[_c('div',{staticClass:"modal"},[_c('div',[_vm._t("default")],2),_c('button',{staticClass:"close-modal button",on:{"click":_vm.close}},[_vm._v("\n      "+_vm._s(_vm.texts.close)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }